import baseAxios from "../core/api/axios/baseAxios";

export default class RaffleService {
  /****************************
   *
   * getter services
   *
   ****************************/
  static async getAllClients(page) {
    const res = await baseAxios.get(`/v2/dashboard/details?type=totalUsers&limit=20&page=${page}`);
    return { ...res.data, data: { ...res.data.data, users: res.data.data.data } };
  }

  /****************************
   *
   * search services
   *
   ****************************/
  static async searchAllClients(searchQuery) {
    const res = await baseAxios.get(`/v2/dashboard/details?type=totalUsers&limit=20&searchTerm=${encodeURIComponent(searchQuery)}`);

    return { ...res.data, data: { ...res.data.data, users: res.data.data.data } };
  }

  /****************************
   *
   * post services
   *
   ****************************/
  static async postRaffle(data) {
    const res = await baseAxios.post(`/organisation/raffle`, data);
    return res?.data || res;
  }
}
